import { Component, OnInit, SimpleChanges, OnChanges, Input } from '@angular/core';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { CustomerBranchService } from 'src/app/_services/dispo/customer-branch.service';
import { AbstractControl, FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TeamBaseService } from 'src/app/_services/dispo/team-base';
import { TeamEventService } from 'src/app/_services/dispo/team-event.service';
import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';


@Component({
  selector: 'app-team-order',
  templateUrl: './team-order.component.html',
  styleUrls: ['./team-order.component.css']
})
export class TeamOrderComponent implements OnInit {
  content: any;
  orderData: any;
  teamForm: any;
  orderTypeList: any;
  customerBranchList: any;
  orderList: any;
  isNew: Boolean = false;
  addNew: Boolean = false;
  customer_id: any;
  submitted = false;
  module_item_id: any;

  constructor(
    private orderService: OrderService,
    private customerBranchService: CustomerBranchService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private teamBaseService: TeamBaseService,
    private teamEventService: TeamEventService,
    private route: ActivatedRoute, 
    private router: Router,
  ) { }

  ngOnInit(): void {
     //get current movie data
    this.module_item_id = this.route.parent.snapshot.params.id;
    alert(this.module_item_id);
    this.teamEventService.show(this.module_item_id).subscribe( data => {
        this.orderData = data;  //store data in variable
        //this.orderTypeList = data.orderTypes;
        this.orderList = data.customers;
        this.customer_id = data.customers.id;
        if(!this.orderData.id) {this.isNew = true};
        this.setForm(data);     //fill form
        //this.initCustomerBranches();
        //this.prepareChangeListener();
      },
      err => { this.content = JSON.parse(err.error).message;}
    );
  }

  get f(): { [key: string]: AbstractControl } {
    return this.teamForm.controls;
  }
  

  setForm(data) {
    this.teamForm = this.fb.group({
      
      //customer_id:                [data.customer_id,Validators.required],
      //customer_branch_id:         [data.customer_branch_id,Validators.required],
      //label:                      [data.label,Validators.required],
      //identity:                   [data.identity,Validators.required],
      //phone:                      [data.phone],
    });
  }



   prepareChangeListener() {
    this.teamForm.get('customer_id').valueChanges.subscribe(id => {
      this.changeCustomer(id);
    });
   }

   initCustomerBranches() {
      this.changeCustomer(this.teamForm.get('customer_id').value);
   }

   changeCustomer(id) {
    this.customerBranchService.byCustomerId(id).subscribe(
      data => {
        this.teamForm.get('customer_branch_id').value = null;
        this.customerBranchList = data;
      },
      err => {
        this.orderList = JSON.parse(err.error).message;
      }
    );
   }

  submit() {
    this.submitted = true;
    if(this.teamForm.valid) { 
      if(this.isNew) {

        //store
        this.teamBaseService.store(this.teamForm.value).subscribe(
          data => {
            this.orderData = data;
            this.toastr.success('Daten gepeichert!');
          },
          err => {
            this.toastr.warning(err.error.message, 'Ein Fehler ist aufgetreten');
    
          }
        );
      } else {

        //update
        this.teamBaseService.update(this.teamForm.value).subscribe(
          data => {
            this.orderData = data;
            this.toastr.success('Daten gepeichert!');
          },
          err => {
            this.toastr.warning(err.error.message, 'Ein Fehler ist aufgetreten');

          }
        );
      };
    } else {
      this.toastr.warning('Formular nicht korrekt', 'Bitte prüfen');
    }

  }

}
